import { makeStyles } from '@material-ui/core/styles'

// Define the standardized tile style that can be imported directly
export const standardTileStyle = {
  backgroundColor: '#ffffff',
  borderRadius: 8, // theme.spacing(1)
  padding: 24, // theme.spacing(3)
  border: '1px solid rgba(0, 0, 0, 0.08)',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)', // Default subtle shadow
  color: 'rgba(0, 0, 0, 0.87)',
  height: '100%',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  boxSizing: 'border-box',
  margin: 0,
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
  },
}

// Main hook for the analytics page itself
const useStyles = makeStyles(theme => {
  return {
    container: {
      padding: theme.spacing(3),
      margin: '0 auto',
      maxWidth: '1200px',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
    // Expose the standardized tile style for external components
    tile: {
      ...standardTileStyle,
      borderRadius: theme.spacing(1), // Use theme spacing for components using this hook
      padding: theme.spacing(3),
    },
    // Main chart style to use for new code
    chart: {
      ...standardTileStyle,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(3),
    },
  }
})

export default useStyles
